import React, { useEffect, memo, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { CompanyActions } from '../../store/actions/companies';
import { PlanActions } from '../../store/actions/plans';
import { UserActions } from '../../store/actions/users';

import Footer from '../../components/Footer2';
import Header from '../../components/Header';
import ConsumptionPlan from '../../components/Plans/ConsumptionPlan/ConsumptionPlan';
import HistoryPlan from '../../components/Plans/HistoryCompany/HistoryPlan';
import DescriptionPlan from '../../components/Plans/DescriptionPlan/DescriptionPlan';
import AlertsPlan from '../../components/Plans/AlertsPlan/AlertsPlan';

import ViewPlans from './ViewPlans';

import iconBack from '../../assets/images/back.svg';

import './index.css';

function Plans() {
  const [viewPage, setViewPage] = useState('plano');

  const user = useSelector((state) => state.users.signedUser);
  const company = useSelector((state) => state.companies.company);
  const plansSelect = useSelector((state) => state.plans.list);

  const dispatch = useDispatch();

  useEffect(() => {
    if (user?._id) {
      dispatch(
        CompanyActions.getCompany({ companyId: user?.selectedCompany._id })
      );
      dispatch(PlanActions.getPlans({ companyId: user?.selectedCompany._id }));
      dispatch(
        PlanActions.getPlanConsumption({
          companyId: user?.selectedCompany._id,
          isFreemium:
            user?.selectedCompany?.plan?.name?.toLowerCase() === 'freemium',
        })
      );
    } else {
      dispatch(UserActions.me());
    }
  }, [user]);

  return (
    <>
      <Header pagetype="page-inicio" />
      <div className="container-page-plan">
        {viewPage === 'plano' ? (
          <div>
            <div className="volta-menu-principal">
              <Link to="/home" style={{ textDecoration: 'none' }}>
                <span className="simbolo-voltar pointer">
                  <img src={iconBack} alt="Voltar" style={{ height: 19 }} />
                </span>
              </Link>
              <img src={require('../../assets/images/menu.svg')} alt="menu" />
              <span>Menu Principal</span>
            </div>
            <p className="title-plan-sector">{`Plano - ${company.fantasyName}`}</p>
            <div className="container-line-page-plan">
              <DescriptionPlan viewPage={viewPage} setViewPage={setViewPage} />
              <ConsumptionPlan />
              <AlertsPlan user={user} company={company} />
            </div>
            <HistoryPlan />
          </div>
        ) : (
          <ViewPlans
            viewPage={viewPage}
            setViewPage={setViewPage}
            plansSelect={plansSelect}
          />
        )}
      </div>
      <Footer />
    </>
  );
}

export default withRouter(memo(Plans));
